export const COURSE_TYPE = [
  {
    label: '首页推荐',
    value: -1,
  },
]

export const COURSE_DETAIL_TAB = [
  {
    title: '课堂详情',
    value: 1,
  },
  {
    title: '课堂选集',
    value: 2,
  },
]

export const VIDEO_TAB_TYPE = [
  { label: '课程', value: 1 },
  { label: '精品', value: 3 },
  { label: '小视频', value: 2 },
]
